/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConfigurationVariables } from "../../../config";
import TextInputField from "../../../utils/text-input-field/TextInputField";
import ConfirmModal from "../../../utils/modals/confirm-modal/ConfirmModal";
import InfoModal from "../../../utils/modals/info-modal/InfoModal";
import { IErrorProps } from "../../../models";
import ToastBarForError from "../../SharedComponents/ToastBarForError";
import "../edit-organisation/EditOrganisation.scss";
import addLogo from "../../../images/addLogo.png";
import UploadProfilePic from "../../../utils/upload-profile-pic/UploadProfilePic";
import { AppDispatch, RootState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import TreeTableOrganizationData from "../../../models/apiModels/TreeTableOrganizationData";
import { TreeSelect } from "primereact/treeselect";
import OrganizationHDTOKey from "../../../models/apiModels/OrganizationHDTOKey";
import {
  editOrganizationbyID,
  fetchLogoOrganization,
  uploadOrgLogoDetails,
} from "../../../store/Organisation/organisation-actions";
import { GetOrgbyKey } from "../../../utils/methods/GetOrgbyKey";
import { organizationActions } from "../../../store/Organisation/organisation-slice";
import getAllParentKeys from "../../../utils/methods/getAllParentKeys";
import getOrganizationKeyByOrgId from "../../../utils/methods/getOrganizationKeyByOrgId";
import Loader from "../../Loader/Loader";
import AcceptTerms from "../../../utils/accept-terms/AcceptTerms";
import DialogForError from "../../SharedComponents/DialogForError";
import BreadCrumbsComponent from "../../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../../SharedComponents/Title/Title";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  ControlError,
  Chip,
  Label,
  ChipRemove,
  Divider,
} from "@forge/common";
import { UUID } from "../../../models/apiModels/Organization";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import updateErrorList from "../../../utils/methods/updateErrorList";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import GetTokenValues from "../../../utils/methods/GetTokenValues";
// import getOrganizationKeyByOrgId from "../../../utils/methods/GetOrganizationKeyByOrgId";
import DefaultProfileImg from "../../../images/addLogo.png";
import DefaultProfileImgDark from "../../../images/DefaultProfileImgDark.png";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../../localization/keys";

// @TODO: Replace with api data once it is ready
// Data has been moved to store

const ORGANISATION_CRUMB_ID = "Organisation";

function EditOrganisation() {
  const [t] = useTranslation();
  const theme = useSelector((state: any) => state?.theme?.currentTheme);
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub,
  };
  const dispatch: AppDispatch = useDispatch();

  const navigate = useNavigate();
  // const location = useLocation();
  const organizationOriginalDataTree: TreeTableOrganizationData[] =
    useSelector((state: RootState) => state.organisation.treeTableOrganization);

  const organisationDetailsToEditStore: {
    tenantId: string;
    UserInfo: TreeTableOrganizationData;
  } = useSelector(
    (state: RootState) => state.organisation.organisationDetailsToEdit
  );
  const [existingProfilePic, setExistingProfilePic] = useState<string>();
  const [userProfilePic, setUserProfilePic] = useState<string>();
  const orgDatafromListPage: TreeTableOrganizationData =
    organisationDetailsToEditStore.UserInfo;
  const [orgName, setOrgName] = useState(orgDatafromListPage.data.name);

  const hierarchicalOrganizationwKey: OrganizationHDTOKey[] = useSelector(
    (state: RootState) => state.organisation.hierarchicalOrganizationwKey
  );

  const selectedKey: string = getOrganizationKeyByOrgId(
    orgDatafromListPage.parentId,
    organizationOriginalDataTree
  )?.key;

  const [selectedNodeKey, setSelectedNodeKey] = useState<any>(selectedKey);

  const [isOrgNameEmpty, setIsOrgNameEmpty] = useState<boolean>(false);
  const [isOrgNameValid, setIsOrgNameValid] = useState<boolean>(true);
  const [parentOrgName, setParentOrgName] = useState(
    GetOrgbyKey(selectedNodeKey, organizationOriginalDataTree)?.data?.name
  );
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);
  const [isFormFilled, setIsFormFilled] = useState<boolean>(false);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const orgNameRegex = /^[a-zA-Z0-9\s]*$/;
  const [isParentValid, setIsParentValid] = useState<boolean>(true);

  /** Effect to set errro dialog or error toastbar state to open */
  // useEffect(() => {
  //   if (
  //     errorList.some((x) => x.errorCode === undefined) &&
  //     !openDialogNoURLError
  //   ) {
  //     setOpenDialogNoURLError(true);
  //   }
  //   if (errorList.some((x) => x.errorCode === 409) && !openDialogforConflict) {
  //     setopenDialogforConflict(true);
  //   }

  //   if (
  //     errorList.some((x) => x.errorCode === 400 || x.errorCode === 409) &&
  //     !openToastError
  //   ) {
  //     setOpenToastError(true);
  //   }
  //   if (
  //     errorList.some(
  //       (x) =>
  //         x.errorCode !== undefined &&
  //         x.errorCode !== 400 &&
  //         x.errorCode !== 409 &&
  //         x.errorCode !== null &&
  //         x.errorCode !== 204
  //     ) &&
  //     !openDialogServerError
  //   ) {
  //     setOpenDialogServerError(true);
  //   }
  // }, [errorList]);

  const cancelBtnHandler = () => {
    setConfirmModal(false);
    navigate("/organization");
  };
  function disableButtonHandeller() {
    const currentParentId = GetOrgbyKey(
      selectedNodeKey,
      organizationOriginalDataTree
    )?.data?.organizationId;
    if (
      orgDatafromListPage.data.name !== orgName ||
      orgDatafromListPage.parentId !== currentParentId
    ) {
      if (orgName == "" || !isOrgNameValid || !isParentValid) {
        return true;
      } else {
        return false;
      }
    } else if (!currentImage) {
      return true;
    }
  }

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [openDialogforConflict, setopenDialogforConflict] = useState(false);
  const [currentImage, setCurrentImage] = useState<File>();
  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);
  const onDialogForConflictCloseHandler = () => {
    setopenDialogforConflict(false);
    navigate("/organization");
  };

  //////////////Error Handling////////////////////////

  /**
   * To display helper text
   * Setting true  in state if any field is empty
   */

  const checkFieldEmpty = () => {
    !orgName && setIsOrgNameEmpty(true);
    !selectedNodeKey.length && setIsParentValid(false);
  };

  useEffect(() => {
    setIsLoading(true);
    const orgInfo = {
      tenantId: tokenInfo.tenant,
      organizationId:
        organisationDetailsToEditStore.UserInfo.data.organizationId,
    };
    dispatch(fetchLogoOrganization(orgInfo))
      .then((response: any) => {
        response.payload.data == 204
          ? setExistingProfilePic(addLogo)
          : setExistingProfilePic(response.payload.data);
      })
      .catch((error) => {
        setExistingProfilePic("");
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  /**
   * Checks if the organisation name, parent org fields input entered
   * @returns boolean - returns fasle if any field is missing
   */
  const hasAllFieldsInput = () => {
    if (orgName && selectedNodeKey.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * @summery
   * input fields validation: empty field check
   * opens confirm model if all mandatory fields entered and valid
   */
  const updateBtnHandler = () => {
    checkFieldEmpty();

    if (hasAllFieldsInput() && !isTermsAccepted) {
      setIsFormFilled(true);
      // setConfirmModal(true);
      setIsTermsAccepted(false);
    }

    // checking if all mandatory fields are filled and open confirm modal
    if (hasAllFieldsInput() && isOrgNameValid && isTermsAccepted) {
      setConfirmModal(true);
    }
    if (hasAllFieldsInput() && parentOrgName && isTermsAccepted) {
      setConfirmModal(true);
      setConfirmModal(true);
    }
  };
  useEffect(() => {
    const ParentId: string = GetOrgbyKey(
      selectedNodeKey,
      organizationOriginalDataTree
    )?.data?.organizationId;
    // setParentOrgId(ParentId);
    setParentOrgName(
      GetOrgbyKey(selectedNodeKey, organizationOriginalDataTree)?.data?.name
    );
  }, [selectedNodeKey]);

  const getOrgNameHelperText = () => {
    let helperText = "";
    if (isOrgNameEmpty) {
      helperText = t(localeKeyMap.pleaseEnterValidName);
    }
    if (!isOrgNameEmpty && !isOrgNameValid) {
      helperText = t(localeKeyMap.organizationNameAlphanumeric);
    }
    return helperText;
  };

  /**
   * To close toast bar
   */
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  /**
   *
   * Saving organisation in database on click confirm create btn
   */
  // istanbul ignore next
  const confirmCreateHandler = () => {
    setConfirmModal(false);
    setErrorListGlobal([]);
    const ParentId = GetOrgbyKey(selectedNodeKey, organizationOriginalDataTree)
      ?.data?.organizationId;
    let reqBody = {
      organizationName: orgName,
      groupId: organisationDetailsToEditStore.UserInfo.data.groupId ?? "",
      parentOrganizationId: ParentId,
      // GetOrgbyKey(selectedNodeKey),
      tenantId: organisationDetailsToEditStore.tenantId,
      organizationId:
        organisationDetailsToEditStore.UserInfo.data.organizationId,
      version: organisationDetailsToEditStore.UserInfo.version,
      //@TODO: TO BE REFACTORED WITH ACTUAL VALUE
    };

    setIsLoading(true);
    dispatch(editOrganizationbyID(reqBody))
      .unwrap()
      .then((response) => {
        setSuccessModal(true);
      })
      .catch((error) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });

    // Saving profile pic in the database when user uploads a new image for the organisation
    if (currentImage) {
      setIsLoading(true);
      if (!organisationDetailsToEditStore) {
        return;
      }
      const parameters: any = {
        tenantId: organisationDetailsToEditStore?.tenantId,
        organizationId:
          organisationDetailsToEditStore?.UserInfo?.data?.organizationId,
        fileName: currentImage,
      };
      dispatch(uploadOrgLogoDetails(parameters))
        .unwrap()
        .then(() => {
          navigate("/organization");
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  /**
   * To set selected parent org in state
   * @param event
   * @param nodeId selected nodeId
   */
  // const onParentOrgSelect = (event: any, nodeId: any | string) => {
  //   setParentOrgId(nodeId);
  //   setParentOrgName(event.target.innerText);
  //   setIsParentOrgEmpty(false);
  // };

  // const handleDelete = () => {
  //   setParentOrgId("");
  //   setParentOrgName("");
  //   setIsParentOrgEmpty(true);
  // };
  const [crumbs, setCrumbs] = useState([
    {
      id: ORGANISATION_CRUMB_ID,
      label: "Organization",
    },
    {
      id: "EditOrganisation",
      label: orgDatafromListPage?.data?.name,
    },
  ]);

  const handleClickChip = () => {
    setParentOrgName("");
    setSelectedNodeKey([]);
    // setParentOrgId("");
    setIsParentValid(false);
  };
  //for ImageUpload submit , on clicking on edit image icon

  const backButtonHandler = () => {
    navigate(-1);
  };

  const handleCrumbClick = (crumb: { id: string; href?: string }) => {
    if (crumb.id === ORGANISATION_CRUMB_ID) {
      navigate("/organization");
    }
  };
  return (
    <>
      <BreadCrumbsComponent
        crumbs={crumbs}
        backbutton={true}
        backButtonHandler={backButtonHandler}
        onCrumbClick={handleCrumbClick}
      />
      <Title
        title={t(localeKeyMap.editOrganization)}
        className="p-t15 "
        buttonRequired={false}
      />
      <Card className="create_user p-b5">
        <React.Fragment key=".0">
          <CardHeader
            title={t(localeKeyMap.organizationProfile)}
            className="sub-header p-20"
          />
          <CardContent className="d-flex main_form_wrap p-20">
            {/* <div className="form_logo_wrap text-center"> */}
            <UploadProfilePic
              labelText={t(localeKeyMap.updateLogo)}
              profilePic={
                !existingProfilePic
                  ? theme === "light"
                    ? DefaultProfileImg
                    : DefaultProfileImgDark
                  : `data:image/png;base64,${existingProfilePic}`
              }
              onImageUpload={(image) => setCurrentImage(image)}
            />
            <div className="form_box" style={{ justifyContent: "unset" }}>
              <h4>{t(localeKeyMap.basicInformation)}</h4>
              <div className="form_col p-10">
                <div className="form_col">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.organizationName)}
                    id="OrgName"
                    type="text"
                    required={true}
                    styleName="text-input-field"
                    //className="widthOfField"
                    placeholder={t(localeKeyMap.organizationName)}
                    disabled={false}
                    value={orgName ?? ""}
                    onChange={(value) => {
                      setOrgName(value);
                      value == ""
                        ? setIsOrgNameEmpty(true)
                        : setIsOrgNameEmpty(false);
                      orgNameRegex.test(value)
                        ? setIsOrgNameValid(true)
                        : setIsOrgNameValid(false);
                    }}
                    error={isOrgNameEmpty || !isOrgNameValid}
                    helperText={getOrgNameHelperText()}
                    dataTestId="orgName"
                  />
                </div>
                <div className="form_col m-t10">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.organizationId)}
                    id="OrgId"
                    type="text"
                    required={false}
                    styleName="text-input-field"
                    placeholder={t(localeKeyMap.organizationId)}
                    disabled={true}
                    value={
                      organisationDetailsToEditStore?.UserInfo?.data
                        ?.groupId ?? ""
                    }
                    dataTestId="orgId"
                  />
                </div>
                <div className="form_col m-t10">
                  <Label requiredText="*"> {t(localeKeyMap.parentOrganizationName)}</Label>
                  <TreeSelect
                    value={selectedNodeKey}
                    className={
                      isParentValid
                        ? "dropdown_tree "
                        : "dropdown_tree p-invalid"
                    }
                    filter
                    onChange={(e) => {
                      const setKeys = e?.value;
                      setIsParentValid(setKeys === null ? false : true);
                      let allParentKeys = getAllParentKeys(setKeys as string);
                      dispatch(
                        organizationActions.setExpandedKeyforEdit(allParentKeys)
                      );
                      setSelectedNodeKey(setKeys);
                    }}
                    options={hierarchicalOrganizationwKey}
                    metaKeySelection={false}
                    selectionMode="single"
                    placeholder={t(localeKeyMap.selectParentOrganization)}
                    style={{
                      width: "100%",
                    }}
                    data-testid="SelectParentOrganisation"
                  ></TreeSelect>
                  {parentOrgName && (
                    <Chip className="theme-chip">
                      {parentOrgName}
                      <ChipRemove
                        onClick={() => handleClickChip()}
                        className="theme-chip-remove"
                      >
                        {parentOrgName}
                      </ChipRemove>
                    </Chip>
                  )}
                  {(parentOrgName === undefined || parentOrgName === "") && (
                    <ControlError className="control-error">
                      {t(localeKeyMap.selectValidParent)}
                    </ControlError>
                  )}
                </div>
              </div>
            </div>
          </CardContent>
        </React.Fragment>
      </Card>
      <div className="create_user p-b15 m-t10">
        <AcceptTerms
          text={t(localeKeyMap.acceptUpdateOrganization)}
          isFormFilled={isFormFilled}
          isTermsAccepted={isTermsAccepted}
          onTermsAccept={(event) => {
            setIsTermsAccepted(event?.target.checked);
          }}
        />
      </div>
      <Divider
        className="h-12"
        orientation="vertical"
        subtitle=""
        subtitlePosition="left"
        type="full-bleed"
      />

      <Card className="footer">
        <Button
          onClick={cancelBtnHandler}
          variant="quiet-primary"
          data-testid="CancelOrgButton"
        >
          {t(localeKeyMap.cancel)}
        </Button>
        <Button
          size="regular"
          variant="primary"
          className="cursor-pointer"
          onClick={updateBtnHandler}
          data-testid="EditOrgButton"
          disabled={disableButtonHandeller()}
        >
          {t(localeKeyMap.update)}
        </Button>
        <ConfirmModal
          dialogTitle={t(localeKeyMap.updateOrganization)}
          dialogContentText={t(localeKeyMap.updateOrganizationConfirm)}
          onConfirmClick={confirmCreateHandler}
          onCancelClick={() => setConfirmModal(false)}
          onCloseClick={() => setConfirmModal(false)}
          open={confirmModal}
          primaryBtnText={t(localeKeyMap.update)}
        />
        <InfoModal
          dialogTitle={t(localeKeyMap.successfullyUpdated)}
          dialogContentText={t(localeKeyMap.organizationUpdated)}
          onOkClick={() => {
            setSuccessModal(false);

            navigate("/organization");
          }}
          open={successModal}
        />
      </Card>

      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={openDialogforConflict}
        onCloseServerConflictError={onDialogForConflictCloseHandler}
      />
      {isLoading && <Loader />}
    </>
  );
}

export default EditOrganisation;